import { PageRequest } from '../page-request.data';
import { Sort } from '../sort.data';
import { Customer } from '../customer';

export interface CustomerState {
  customers: Customer[];
  pageRequest: PageRequest;
  loading: boolean;
  saving: boolean;
  completed: boolean;
  externalNames: string[];
  externalNamesLoading: boolean;
}

export const initialCustomerState: CustomerState = {
  customers: [],
  pageRequest: {
    page: 0,
    size: 20,
    sort: {} as Sort,
    searchText: '',
  },
  loading: true,
  saving: false,
  completed: false,
  externalNames: [],
  externalNamesLoading: false,
};
